module.exports = __webpack_public_path__ + "img/eg.c79853fe.svg";